import './main';
// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper/swiper-bundle.js';
// import Swiper and modules styles

import "swiper/swiper.scss";
import "swiper/modules/pagination/pagination.scss";
import "swiper/modules/navigation/navigation.scss";


window.addEventListener('DOMContentLoaded', () => {

    

    const swiper = new Swiper('.swiper', {
        // Optional parameters
        direction: 'horizontal',
        slidesPerView: "auto",
        loop: false,
      
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      
        // And if we need scrollbar
        scrollbar: {
          el: '.swiper-scrollbar',
        },
    });    

});

